export const config = {
  title: "Voltus Energy Solutions",
  meta: {
    description:
      "Voltus Energy Solutions delivers advanced energy solutions including EV charger installation, battery backup systems, and solar panel integration across Montclair, NJ and beyond.",
    keywords: [
      "EV Charger Installation",
      "Energy Storage",
      "Battery Backup Montclair",
      "Solar Energy Solutions",
      "Voltus Energy Solutions",
      "Montclair NJ Electrical Services"
    ],
    author: "Voltus Energy Solutions",
    canonicalUrl: "https://voltusenergysolutions.com/",
  },
  sections: {
    header: {
      businessName: "Voltus Energy Solutions",
    },
    sectionB: {
      heroTitle: "Voltus Energy Solutions",
      heroSubtitle: "Powering the Future with Clean and Efficient Energy",
      learnAboutText: "Explore Our Services",
      phoneNumber: "9735618463",
      phoneLabel: "(973) 561-8463",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1665925516/photo/renewable-energy-solar-panels-and-team-walking-on-roof-planning-for-inspection-at-sustainable.jpg?s=612x612&w=0&k=20&c=gEUl4TPBqLNZiQQDnyI217t46oxYMnz9Xz9jcR8avjk=",
      cardData: [
        {
          title: "EV Charging Solutions",
          description:
            "Install and maintain electric vehicle chargers for homes and businesses.",
        },
        {
          title: "Battery Backup Systems",
          description:
            "Ensure energy security with reliable battery storage solutions.",
        },
        {
          title: "Renewable Integration",
          description:
            "Upgrade your property with solar and smart energy technologies.",
        },
      ],
      description:
        "Voltus Energy Solutions specializes in electric vehicle charging stations, energy storage, and renewable energy integration for residential and commercial properties in Montclair, NJ and surrounding regions.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Discover energy-efficient and future-ready services tailored to your power needs.",
      cards: [
        {
          title: "EV Charger Installation",
          description:
            "Expert installation for Level 2 and commercial-grade EV chargers.",
          imageSrc: "https://media.istockphoto.com/id/1317379446/photo/close-up-of-charging-cable-plugged-into-the-side-of-electric-car-car-or-electric-vehicle-eco.jpg?s=612x612&w=0&k=20&c=x_dsfRkZzNT6z3z7FJ2O2kB7bQlKtfr7ZRWJFJ12wHI=",
          imageAlt: "EV Charger Installation",
        },
        {
          title: "Battery Backup Installation",
          description:
            "Custom-configured battery storage to keep you powered during outages.",
          imageSrc: "https://media.istockphoto.com/id/2211089749/photo/solar-battery.jpg?s=612x612&w=0&k=20&c=X4qb6GADqotlUdMtZDti4wCGJxWZQRWYMrgoWGjXcNk=",
          imageAlt: "Battery Backup Systems",
        },
        {
          title: "Energy Efficiency Consulting",
          description:
            "Energy audits and system optimization for smarter energy use.",
          imageSrc: "https://media.istockphoto.com/id/2095813668/photo/asian-woman-lead-young-group-of-multiethnic-businesspeople-in-team-meeting-using-laptop.jpg?s=612x612&w=0&k=20&c=jD-uEwJDIXlsQx1-tQX3cMnf0e81yAvf9pyAUuNhoYw=",
          imageAlt: "Energy Efficiency Consulting",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Load Panel Upgrades",
        "Smart Home Energy Integration",
        "Solar Panel Compatibility Setup",
        "EV Fleet Consultation",
        "Permit & Inspection Handling",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://voltusenergysolutions.com/wp-content/uploads/2025/07/voltusenergy-color-logo-01.avif",
        alt: "Voltus Energy Team",
      },
      aboutText: [
        "Voltus Energy Solutions is a New Jersey-based provider of high-performance electrical and energy systems, committed to delivering sustainable and intelligent energy solutions.",
        "With a passion for innovation and a mission to create a cleaner energy future, our team brings deep expertise and exceptional service to every project.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Voltus Energy Solutions Logo",
      businessName: "Voltus Energy Solutions",
      contact: {
        phone: "9735618463",
        phoneLabel: "(973) 561-8463",
        email: "info@voltusenergysolutions.com",
        website: "https://voltusenergysolutions.com/",
        address: "18-20 Lackawanna Plz, Montclair, NJ 07042",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "18-20 Lackawanna Plz, Montclair, NJ 07042",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.225699440342!2d-74.2100792845926!3d40.81491477931921!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f4cc4fa01cf3%3A0x59cd9e8b83b6f07!2s18-20%20Lackawanna%20Plaza%2C%20Montclair%2C%20NJ%2007042%2C%20USA!5e0!3m2!1sen!2sph!4v1719446000000!5m2!1sen!2sph",
    },
  },
};

export default config;
